import axios from "./axios";

export async function GetFunction({
  Route,
  data,
  showalert,
}) {
  try {


    console.log({
      name: "This data send to " + Route + " :===>",
      data,
      type: "api",
    });
    const res = await axios.get(
      Route,
      { params: data }
    );
    if (res) {

      console.log({
        name: "This response from " + Route + " <===:",
        data: res?.data,
        type: "api",
      });

      if (res?.data) {
        return res.data;
      } else if (res) {
        return res;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } catch (err) {
    throw new Error(err?.response?.data?.message ?? err.message);
  }
}

export async function PostFunction({
  Route,
  data,
  showalert,
  isMultipart = true,
  state,
  dispatch,
}) {
  try {


    let header;
    if (isMultipart) {
      header = {
        method: "post",
        url: Route,
        data: data,
        headers: {
          "Content-Type": "multipart/form-data",
          accept: "application/json",
        },
      };
    } else {
      header = {
        method: "post",
        url: Route,
        data: data,
      };
    }
    const res = await axios(header);
    if (res) {
      console.log({
        name: "This response from " + Route + " <===:",
        data: res?.data,
        type: "api",
      });

      if (res?.data) {
        return res.data;
      } else if (res) {
        return res;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } catch (err) {



    throw new Error(err?.response?.data?.message ?? err.message);
  }
}
